import React from 'react';
// @mui
import { Box, IconButton, Dialog, DialogTitle, DialogContent, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
export var ScrollDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, children = _a.children;
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        React.createElement(DialogTitle, { sx: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 24px',
            } },
            React.createElement(Box, { sx: {
                    typography: function (theme) { return theme.customTypography.subtitle2; },
                } }, title),
            React.createElement(IconButton, { onClick: onClose },
                React.createElement(CloseIcon, null))),
        React.createElement(DialogContent, null, children)));
};
